import React from 'react';
import { string, node } from 'prop-types';
import classNames from 'classnames/bind';

import styles from './Container.module.scss';
const cx = classNames.bind(styles);

Container.propTypes = {
  className: string,
  children: node.isRequired,
};

Container.defaultProps = {
  className: null,
};

export default function Container({ children, className }) {
  return <div className={cx('container', className)}>{children}</div>;
}



// WEBPACK FOOTER //
// ./src/components/Container/Container.js